<template>
  <div class="container clinic-products">
    <clinic-show-product ref="showproduct" @submit="onSubmit"></clinic-show-product>
    <clinic-change-stock ref="changestock" @submit="onSubmit"></clinic-change-stock>
    <!-- HEADER -->
    <div class="row mb-4 title-row">
      <div class="col-sm-3 text-left">
        <h1 class="page-title">TRATAMIENTOS</h1>
      </div>
      <div class="col-sm-2 text-left">
        <button @click="addNewProduct" type="button" class="btn btn-wabident-round">
          <i class="fas fa-plus mr-1"></i> Nuevo
        </button>
      </div>
      <div class="col"></div>
      <div v-if="is_admin" class="col-sm-3">
        <b-form-file v-model="file" accept=".csv" :state="Boolean(file)" placeholder="Elige .csv para subir"
          class="wabident-file-input">
        </b-form-file>
      </div>
      <div v-if="is_admin" class="col-sm-2">
        <button :disabled="!file || is_searching" @click="importCSV" type="button"
          class="btn btn-wabident-round btn-block">
          Importar
        </button>
      </div>
    </div>

    <!-- INPUT -->
    <div class="row my-2">
      <div class="col-sm-4">
        <input v-model="search" class="form-control icon" type="search" name="search" id="product_index_search"
          placeholder="Nombre del tratamiento/producto" />
      </div>

      <div class="col-sm-4">
        <select v-model="product_category_id" id="product_category_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="category, id in categories" :key="id" :value="category.id">{{ category.name }}
          </option>
        </select>
        <label for="product_category_id" class="wabident-info">Unidad</label>
      </div>

      <div class="col-sm-2">
        <select v-model="type" id="product_show_types" class="custom-select">
          <option :value="null">Todos</option>
          <option value="treatment">Tratamientos</option>
          <option value="product">Productos</option>
        </select>
        <label for="product_show_types" class="wabident-info">Tipo</label>
      </div>

      <div class="col-sm-2">
        <select v-model="show_disabled" id="product_show_disabled" class="custom-select">
          <option :value="false">No</option>
          <option :value="true">Sí</option>
        </select>
        <label for="product_show_disabled" class="wabident-info">Mostrar Inactivos</label>
      </div>
    </div>

    <!-- TOOL BOX -->
    <div class="row my-2">
      <div class="col"></div>

      <div v-if="products_availability_per_clinic && is_admin" class="col-sm-4">
        <select v-model="clinic_id" id="product_clinic_id" class="custom-select">
          <option v-if="is_admin" :value="null">Todas</option>
          <option :value="id" v-for="(name, id) in available_clinics" :key="id"> {{ name }}</option>
        </select>
        <label for="product_clinic_id" class="wabident-info">Disponible en clínica</label>
      </div>

      <div class="col-sm-2 text-center">
        <select v-model="report_type" id="product_show_report_type" class="custom-select">
          <option value="xls">Excel</option>
          <option value="xls">CSV</option>
          <option v-if="stocks_enabled" value="stock">Informe de stock</option>
        </select>
        <label for="product_show_report_type" class="wabident-info">Tipo de informe</label>
      </div>

      <transition name="fade">
        <div v-if="report_type == 'stock'" class="col-sm-2 text-center">
          <select v-model="period" id="product_show_period" class="custom-select">
            <option value="day">Hoy</option>
            <option value="day_prior">Ayer</option>
            <option value="week">Esta semana</option>
            <option value="week_prior">Semana pasada</option>
            <option value="month">Este mes</option>
            <option value="month_prior">Mes pasado</option>
            <option value="trimester">Este trimestre</option>
            <option value="trimester_prior">Trimestre pasado</option>
            <option value="year">Este año</option>
            <option value="past_year">Año pasado</option>
            <option value="custom">Personalizado</option>
          </select>
          <label for="product_show_period" class="wabident-info">Periodo</label>
        </div>
      </transition>

      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom' && report_type == 'stock'">
          <input v-model="date_from" id="clinic_products_date_from" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_products_date_from">Desde:</label>
        </div>
      </transition>

      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom' && report_type == 'stock'">
          <input v-model="date_to" id="clinic_products_date_to" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_products_date_to">Hasta:</label>
        </div>
      </transition>

      <div class="col-sm-2 text-center">
        <button @click="downloadProducts" type="button" class="btn btn-wabident btn-block">
          <i class="fas fa-download mr-1"></i>Descargar
        </button>
      </div>
    </div>

    <!-- RESULTS -->
    <div class="row">
      <div class="col-sm-12">
        <div v-show="!has_results_available" class="text-center">
          <h2 class="product-search-empty-message my-4">{{ empty_message }}</h2>
        </div>
        <div v-show="has_results_available" class="product-search-wrapper">
          <table class="table product-search-results">
            <thead>
              <tr>
                <th colspan="7">TRATAMIENTO</th>
                <th colspan="2">TIPO</th>
                <th colspan="2">UNIDAD</th>
                <th colspan="2">PRECIO</th>
                <th colspan="2">ESTADO</th>
                <th class="text-center" colspan="2">CODIGO</th>
                <th v-if="stocks_enabled" class="text-center" colspan="2">STOCK</th>
              </tr>
            </thead>
            <tbody>
              <tr class="product-search-results__row" v-for="(product, index) in products" :key="index">
                <td colspan="7" @click="productClicked(product)">{{ product.name }}</td>
                <td colspan="2" @click="productClicked(product)">
                  {{ product.type == "treatment" ? "Tratamiento" : "Producto" }}
                </td>
                <td colspan="2" @click="productClicked(product)">
                  {{ product.category ? product.category.name : "" }}
                </td>
                <td colspan="2" @click="productClicked(product)">{{ product.price }}</td>
                <td colspan="2" @click="productClicked(product)">
                  {{ product.disabled ? "Inactivo" : "Activo" }}
                </td>
                <td class="product-code text-center" colspan="2" @click="productClicked(product)">{{
                  product.code }}
                </td>
                <td v-if="stocks_enabled" class="text-center" colspan="2">
                  <div class="product-stock d-flex align-items-center justify-content-center"
                    v-if="product.enable_stock">
                    <button @click="decStock(product)" class="btn btn-wabident-round xsmall mx-1">
                      -
                    </button>
                    {{ product.stock }}
                    <button @click="incStock(product)" class="btn btn-wabident-round xsmall mx-1">
                      +
                    </button>
                  </div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
        <div v-show="has_results_available" class="product-search-pagination text-center">
          <button @click="goFirst" :disabled="is_first_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button @click="goPrev" :disabled="is_first_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-left"></i>
          </button>
          <label class="customer-search-pagination-locator mx-2">
            Página
            {{ current_page }} de {{ total_pages }}
          </label>
          <button @click="goNext" :disabled="is_last_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-right"></i>
          </button>
          <button @click="goLast" :disabled="is_last_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      file: null,
      type: null,
      search: "",
      search_results: [],
      show_disabled: false,
      is_searching: false,
      selected_product: null,
      product_category_id: null,
      report_type: 'xls',
      period: 'week',
      date_from: null,
      date_to: null,
      hierarchy: [],
      clinic_id: null,
    };
  },
  computed: {
    available_clinics() {
      if (!this.clinic) return '';
      return this.clinic.clinic_names;
    },
    products_availability_per_clinic() {
      if (!this.clinic) return false;
      return Boolean(this.clinic.config.products_availability_per_clinic);
    },
    is_admin() {
      return this.current_role == 'admin';
    },
    categories() {
      let ret = [];
      this.hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    stocks_enabled() {
      if (!this.clinic) return false;
      return this.clinic.config.products_enable_stock || false;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == this.search_results.last_page;
    },
    current_page() {
      if (!this.search_results) return 0;
      return this.search_results.current_page;
    },
    total_pages() {
      if (!this.search_results) return 0;
      return this.search_results.last_page;
    },
    products() {
      if (!this.search_results) return [];
      if (!this.search_results.data) return [];

      return this.search_results.data;
    },
    has_results_available() {
      return this.products.length != 0;
    },
    empty_message() {
      if (this.search == "") {
        return "";
      } else {
        return "Lo siento, no pude encontrar ningún producto con ese nombre";
      }
    },
    ...mapGetters(["msgwindow", "clinic", "current_role"]),
  },
  watch: {
    clinic_id(val) {
      this.searchProducts(0);
    },
    product_category_id(val) {
      this.searchProducts(0);
    },
    search(val) {
      this.searchProducts(0);
    },
    type(val) {
      this.searchProducts(0);
    },
    show_disabled(val) {
      this.searchProducts(0);
    },
  },
  methods: {
    addCategory(cat, ret, level) {
      let prefix = '-'.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    goNext() {
      this.searchProducts(this.current_page + 1);
    },
    goPrev() {
      this.searchProducts(this.current_page - 1);
    },
    goFirst() {
      this.searchProducts(1);
    },
    goLast() {
      this.searchProducts(this.total_pages);
    },
    userCan(capability) {
      if (!this.clinic) return false;
      return this.clinic.capabilities[capability] || false;
    },
    downloadProducts() {
      let params = this.getSearchParams();
      let query = new URLSearchParams(params);

      for (const key in params) {
        const val = params[key];
        if (val)
          query.append(key, val);
      }

      query.append('report_type', this.report_type);
      query.append('period', this.period);
      query.append('date_from', this.date_from);
      query.append('date_to', this.date_to);
      query.append('filter_clinic_id', this.clinic_id);

      const url = "/product/csv?" + query.toString()
      console.log(url);

      window.open(url, "_blank");
    },
    addNewProduct() {
      if (!this.userCan('agenda_only')) {
        this.$refs.showproduct.showNew();
      }
    },
    productClicked(prod) {
      if (!this.userCan('agenda_only')) {
        this.$refs.showproduct.showEdit(prod);
      }
    },
    onSubmit() {
      this.searchProducts(this.current_page);
    },
    incStock(product) {
      this.$refs.changestock.show(product, 'inc');
    },
    decStock(product) {
      this.$refs.changestock.show(product, 'dec');
    },
    loadCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.hierarchy = response.data;
        });
    },
    importCSV() {
      if (!this.is_searching) {
        this.is_searching = true;
        let formData = new FormData();
        formData.append("file", this.file);

        axios
          .post("/product_import_csv", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.msgwindow.success("Productos importados con éxito");
          })
          .catch((err) => {
            this.msgwindow.error("Error importando documentos");
          })
          .then(() => {
            this.file = null;
            this.is_searching = false;
            this.searchProducts(0);
          });
      }
    },
    getSearchParams(page = null) {
      let params = {
        search: this.search,
        filter_clinic_id: this.clinic_id,
      };

      if (this.product_category_id) {
        params.product_category_id = this.product_category_id;
      }

      if (page) {
        params.page = page;
      }

      if (this.show_disabled) {
        params.show_disabled = true;
      }

      if (this.type) {
        params.type = this.type;
      }

      return params;
    },
    searchProducts(page = null) {
      if (!this.is_searching) {
        this.is_searching = true;
        axios
          .get("/product", { params: this.getSearchParams(page) })
          .then((response) => {
            this.search_results = response.data;
          })
          .catch((err) => {
            console.log("[ERR] searchProducts", err);
            this.msgwindow.error("Error buscando productos");
          })
          .then(() => {
            this.is_searching = false;
          });
      }
    },
  },
  mounted() {
    this.searchProducts();
    this.loadCategories();
  },
};
</script>

<style lang="scss">
.clinic-products {
  margin-top: 54px;
}

.title-row {
  border-bottom: 1px var(--theme-grey-bg) solid;
  padding-bottom: 15px;
}

.page-title {
  font-size: 32px;
  color: var(--theme-text-color);
  letter-spacing: 0.5px;
  line-height: 1 !important;
  font-weight: 500;
  margin: 0 !important;
}

.product-search-empty-message {
  color: var(--theme-grey);
  font-size: 24px;
}

.product-search-wrapper {
  margin-top: 30px;
  width: 100%;
}

.product-search-results {
  width: 100%;

  th {
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
    position: sticky;
    background-color: white;
    top: 0;
  }

  &__row {
    cursor: pointer;
    background-color: transparent;
    transition: all 0.2s;
    border: none;
    border-bottom: 1px #e0e0e0 solid;

    &:hover {
      background-color: var(--theme-highlight);
    }

    td {
      font-size: 16px;
      line-height: 20px;
      color: var(--theme-text-color);

      &.product-code,
      &.product-icon {
        color: var(--theme-grey);
        text-transform: uppercase;

        svg {
          fill: currentColor;
        }
      }
    }
  }
}
</style>
